import { CustomValidators } from '..';
declare const moment: any;

export function isPresent(obj: any): boolean {
  return obj !== undefined && obj !== null;
}
export function isMultiParams(str: string): any {
  const array = str.split(',');
  if (array.length > 1) {
    return array;
  } else {
    return false;
  }
}

export function isProperty (element) {
  return element.split(CustomValidators._isProperty)[1] ? element.split(CustomValidators._isProperty)[1] : false;
}

export function isDate(value: any): boolean {
  return moment(new Date(value)).isValid();
  // return value instanceof Date && !isNaN(value.valueOf());
  // return !/Invalid|NaN/.test(new Date(obj).toString());
}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/custom-validators/utils/helpers.ts